// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip-module__tooltip___29TLv","question":"Tooltip-module__question___2Dehz","information":"Tooltip-module__information___MIZMQ"};